import React from 'react';
import { Button } from '@mui/material';

type CustomButtonProps = {
  id?: string;
  text: string;
  disabled?: boolean;
  onClick: () => void;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  disableElevation?: boolean;
  size?: 'small' | 'medium' | 'large';
  style?: any;
  variant?: 'text' | 'contained' | 'outlined';
  color?:
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'error'
  | 'info'
  | 'warning';
};

export const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  style,
  onClick,
  endIcon = null,
  size = 'medium',
  disabled = false,
  variant = 'text',
  color = 'inherit',
  startIcon = null,
  disableElevation = true,
}) => {
  return (
    <Button
      id={''}
      size={size}
      style={{ fontWeight: 'bold', borderRadius: 8, ...style }}
      color={color}
      onClick={onClick}
      variant={variant}
      endIcon={endIcon}
      disabled={disabled}
      startIcon={startIcon}
      disableElevation={disableElevation}
    >
      {text}
    </Button>
  );
};
